/**
 *  页面曝光时间埋点
 * 离开/刷新页面 发送
 * 关闭缓存页签/浏览器页签 发送
 * 浏览器页签切换/最小化浏览器 发送
 *  @param  event  String  埋点事件名
 */
import { handleParameter } from '@/filters';

// eslint-disable-next-line
export default function (event = '') {
    return {
        data() {
            return {
                MIXIN_start_time: null,
                // 页面是否挂载
                MIXIN_first: true,
                // 是否在当前页
                MIXIN_in: true,
            };
        },
        mounted() {
            this.MIXIN_init();
        },
        methods: {
            async MIXIN_init() {
                this.MIXIN_first = false;
                this.MIXIN_start_time = new Date().getTime();
                // 刷新页面/关闭浏览器页签 发送
                window.addEventListener('beforeunload', this.MIXIN_sendPointMessage);
                // 浏览器页签切换/最小化浏览器 发送
                window.addEventListener('visibilitychange', this.MIXIN_broswerChange);
            },
            // 发送埋点信息
            MIXIN_sendPointMessage() {
                if (!this.MIXIN_start_time) return;
                const time = (new Date().getTime() - this.MIXIN_start_time) / 1000;
                handleParameter({
                    trackKey: event,
                    attr: {
                        exposure: parseInt(time.toFixed()),
                    },
                });
                this.MIXIN_start_time = null;
            },
            MIXIN_broswerChange(e) {
                if (!this.MIXIN_in) return;
                if (e.path[0].hidden) {
                    this.MIXIN_sendPointMessage();
                } else {
                    this.MIXIN_start_time = new Date().getTime();
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (!vm.MIXIN_first) vm.MIXIN_init();
                // eslint-disable-next-line no-param-reassign
                vm.MIXIN_in = true;
            });
        },
        // 离开页面发送
        beforeRouteLeave(to, from, next) {
            this.MIXIN_sendPointMessage();
            this.MIXIN_in = false;
            next();
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.MIXIN_sendPointMessage);
            window.removeEventListener('visibilitychange', this.MIXIN_broswerChange);
        },
    };
}
